import React, { FormEvent } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import LoginForm from './Loginform';
import { FormValues, Loginprops } from './Login.types';
import Form from '../../../components/Form/Form';
import { loginService } from '../../../services/Auth/Auth';
import { AuthContext } from '../../../context/Auth/Auth';

const Login = ({ showModalError, returnUrl }: Loginprops) => {
  const { register, handleSubmit, formState } = useForm<FormValues>();
  const { updateContext } = React.useContext(AuthContext);
  const history = useHistory();

  const loginRequest = React.useCallback(
    async (formValues: FormValues) => {
      try {
        const { user, token } = await loginService(formValues);
        updateContext(token, user);
        history.replace(returnUrl);
      } catch (error) {
        if (error instanceof Error) showModalError(error.message);
      }
    },
    [showModalError, updateContext, history, returnUrl]
  );

  const onSubmit = React.useCallback(
    (event: FormEvent) => {
      event.preventDefault();
      handleSubmit(loginRequest)();
    },
    [loginRequest, handleSubmit]
  );

  return (
    <Form form={{ title: 'Iniciar sesión', onSubmit, backHref: returnUrl }}>
      <LoginForm register={register} formState={formState} />
    </Form>
  );
};

export default Login;
